import {
  GET_REGIONS,
  GET_REGIONS_ERROR,
  GET_REGIONS_SUCCESS,
  GET_REGIONAL_KPIS,
  GET_REGIONAL_KPIS_ERROR,
  GET_REGIONAL_KPIS_SUCCESS
} from './RegionalSection.actions'

const regionalSectionState = {
  amount: 0,
  amountUSD: 0,
  biddings: 0,
  error: null,
  id: null,
  loadingKPIs: false,
  loadingRegions: false,
  name: '',
  orders: 0,
  regions: []
}

/**
 * The regional section's reducer.
 */
const regionalSectionReducer = (state = regionalSectionState, { payload, type }) => {
  switch (type) {
    case GET_REGIONS: {
      return { ...state, loadingRegions: true }
    }
    case GET_REGIONS_ERROR: {
      return { ...state, error: payload.error, loadingRegions: false }
    }
    case GET_REGIONS_SUCCESS: {
      return { ...state, loadingRegions: false, regions: payload.options }
    }
    case GET_REGIONAL_KPIS: {
      return { ...state, loadingKPIs: true }
    }
    case GET_REGIONAL_KPIS_ERROR: {
      return { ...state, error: payload.error, loadingKPIs: false }
    }
    case GET_REGIONAL_KPIS_SUCCESS: {
      return {
        ...state,
        amount: payload.amount,
        amountUSD: payload.amountUSD,
        biddings: payload.biddings,
        id: payload.id ? Number.parseInt(payload.id, 10) : null,
        loadingKPIs: false,
        name: payload.name,
        orders: payload.orders
      }
    }
    default: {
      return state
    }
  }
}

export default regionalSectionReducer
